import SupervisorAccount from '@material-ui/icons/SupervisorAccount';

import List from './List';

export default {
  list: List,
  icon: SupervisorAccount,
};
